/**
 * Extracts error message from API response
 * @param error - The error object from axios
 * @returns The extracted error message or null if not found
 */
export function extractApiErrorMessage(error: any): string | null {
  try {
    if (error == null) {
      return null;
    }

    if (typeof error === 'string') {
      return error;
    }

    const hasAxiosResponseData = error?.response && 'data' in error.response;

    if (hasAxiosResponseData && !error.response?.data) {
      return null;
    }

    let responseData = hasAxiosResponseData ? error.response.data : error;

    // Handle ArrayBuffer response
    if (responseData instanceof ArrayBuffer) {
      const decoder = new TextDecoder('utf-8');
      responseData = JSON.parse(decoder.decode(responseData));
    }

    if (typeof responseData === 'string') {
      return responseData;
    }

    if (Array.isArray(responseData)) {
      const firstItem = responseData[0];

      if (typeof firstItem === 'string') {
        return firstItem;
      }

      return firstItem?.mensagem || firstItem?.message || firstItem?.error_description || firstItem?.error || null;
    }

    // Try different error message formats
    if (responseData?.mensagem) {
      return responseData.mensagem;
    }

    if (responseData?.message) {
      return responseData.message;
    }

    if (responseData?.error_description) {
      return responseData.error_description;
    }

    if (responseData?.error) {
      return responseData.error;
    }

    if (responseData?._embedded?.errors?.[0]?.message) {
      return responseData._embedded.errors[0].message;
    }

    if (responseData?.embedded?.errors?.[0]?.message) {
      return responseData.embedded.errors[0].message;
    }

    if (responseData?.errors?.[0]?.message) {
      return responseData.errors[0].message;
    }
  } catch (parseError) {
    console.error('Erro ao fazer parse da mensagem de erro:', parseError);
  }

  return null;
}
